var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)",
    stroke: "#7E898F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 1.25h-12.5A3.75 3.75 0 0010 5v30a3.75 3.75 0 003.75 3.75h12.5A3.75 3.75 0 0030 35V5a3.75 3.75 0 00-3.75-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.25h1.875a.625.625 0 01.625.625 1.25 1.25 0 001.25 1.25h5a1.25 1.25 0 001.25-1.25.625.625 0 01.625-.625h1.875"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone-outline.7a431ad87856b5b2ea483df4d2833544.svg";
export { ForwardRef as ReactComponent };